import { c as _c } from "react/compiler-runtime";
import { RenderElementProps } from 'slate-react';
type BlockQuoteElementProps = RenderElementProps;
export function BlockQuoteElement(props) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props.attributes || $[1] !== props.children) {
    t0 = <blockquote {...props.attributes}>{props.children}</blockquote>;
    $[0] = props.attributes;
    $[1] = props.children;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}